import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  scrollToElement(
    element: HTMLElement,
    scroll?: boolean,
    block?: ScrollLogicalPosition
  ) {
    element.focus({ preventScroll: scroll === false ? scroll : true });
    element.scrollIntoView({
      behavior: 'smooth',
      block: block ? block : 'start'
    });
  }
}
